import theme from '../../base';

const link = {
  focus: {
    border: theme.colors.blues.blue300,
  },
  primary: {
    foreground: theme.colors.blues.blue300,
    foregroundHover: theme.colors.blues.blue200,
    foregroundActive: theme.colors.blues.blue300,
  },
  secondary: {
    foreground: theme.colors.neutrals.gray200,
    foregroundHover: theme.colors.neutrals.white,
    foregroundActive: theme.colors.neutrals.gray200,
  },
};

export default link;
